var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"inset":"","label":_vm.st(_vm.config.label)},on:{"change":_vm.handleInputChange},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }